import { useTranslation } from 'react-i18next';

const TextosConfirmadaReserva = ({ datostransferencia }) => {
    const { t } = useTranslation();
    return (
        <div className="container mt-5">
            <h3 className="centra">{t("Gracias por su reserva")}</h3>
            <p className="centra" dangerouslySetInnerHTML={{ __html: datostransferencia }}></p>
        </div>
    );
}

export default TextosConfirmadaReserva;
